import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Edit, FileDownload, OverflowMenu, TrashDelete } from '@/assets/icons'
import { IconButton } from '@/components/icon-button/IconButton'
import { MenuContent, MenuItemGroup, MenuSeparator } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'

type SkillActionsMenuProps = {
  name: string
  onDownload: () => void
  onEdit?: () => void
  onDelete?: () => void
}

export default function SkillActionsMenu({ name, onDownload, onEdit, onDelete }: SkillActionsMenuProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton icon={<OverflowMenu />} variant="plain" color="neutral" size="sm" aria-label={`Actions for ${name}`} />
      </DropdownMenu.Trigger>
      <MenuContent side="bottom" align="end" className="w-60">
        <MenuItemGroup>
          {onEdit && <MenuItem label="Edit skill" icon={Edit} variant="neutral" onSelect={onEdit} />}
          <MenuItem label="Download as .md" icon={FileDownload} variant="neutral" onSelect={onDownload} />
        </MenuItemGroup>
        {onDelete && (
          <>
            <MenuSeparator />
            <MenuItemGroup>
              <MenuItem label="Delete" icon={TrashDelete} variant="destructive" onSelect={onDelete} />
            </MenuItemGroup>
          </>
        )}
      </MenuContent>
    </DropdownMenu.Root>
  )
}
